import React, { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAdminShell } from "../contexts/adminShellContext";

// The two things staff use all day sit at the top level; everything that is
// set up once and rarely touched lives under Configurations.
const CONFIG_LINKS = [
  { to: "/products", icon: "fa-shopping-bag", label: "Products" },
  { to: "/category", icon: "fa-layer-group", label: "Categories" },
  { to: "/customers", icon: "fa-address-book", label: "Customers" },
  { to: "/users", icon: "fa-user", label: "Users" },
  { to: "/units", icon: "fa-box", label: "Units" },
  { to: "/orderstatus", icon: "fa-shipping-fast", label: "Order Status" },
  { to: "/banners", icon: "fa-images", label: "Banners" },
];

const Sidebar = () => {
  const sidebarRef = useRef(null);
  const { drawerOpen, closeDrawer } = useAdminShell();
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(
    localStorage.getItem("isSubMenuOpen") === "true"
  );

  // Below the drawer breakpoint, a click anywhere outside the panel closes it.
  useEffect(() => {
    if (!drawerOpen) return undefined;

    const handleOutsideClick = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        closeDrawer();
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") closeDrawer();
    };

    document.addEventListener("mousedown", handleOutsideClick);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [drawerOpen, closeDrawer]);

  const toggleSubMenu = () => {
    const newSubMenuState = !isSubMenuOpen;
    setIsSubMenuOpen(newSubMenuState);
    localStorage.setItem("isSubMenuOpen", newSubMenuState);
  };

  return (
    <div ref={sidebarRef}>
      <aside
        className={`navbar-aside${drawerOpen ? " show" : ""}`}
        id="offcanvas_aside"
      >
        <div className="aside-top">
          <Link to="/orders" className="brand-wrap" onClick={closeDrawer}>
            <img
              src="/images/icon-sm.png"
              className="tfmadm-mark"
              alt=""
              aria-hidden="true"
            />
            <span className="tfmadm-wordmark">
              <span className="tfmadm-wordmark__name">Tripoli Fresh Market</span>
              <span className="tfmadm-wordmark__kind">Wholesale</span>
            </span>
          </Link>
        </div>

        <nav>
          <ul className="menu-aside">
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link-header"
                to="/orders"
                onClick={closeDrawer}
              >
                <span className="menu-heading">Orders</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink
                activeClassName="active"
                className="menu-link-header"
                to="/pricelist"
                onClick={closeDrawer}
              >
                <span className="menu-heading">Price List</span>
              </NavLink>
            </li>

            <button
              type="button"
              className="menu-heading tfmadm-group"
              onClick={toggleSubMenu}
              aria-expanded={isSubMenuOpen}
              aria-controls="tfmadm-config"
            >
              Configurations
              <i
                className={`iconfig fas ${
                  isSubMenuOpen ? "fa-chevron-up" : "fa-chevron-down"
                } submenu-toggle`}
                aria-hidden="true"
              ></i>
            </button>

            {isSubMenuOpen && (
              <ul className="menu-aside" id="tfmadm-config">
                {CONFIG_LINKS.map(({ to, icon, label }) => (
                  <li className="menu-item" key={to}>
                    <NavLink
                      activeClassName="active"
                      className="menu-link"
                      to={to}
                      onClick={closeDrawer}
                    >
                      <i
                        className={`icon fas ${icon}`}
                        style={{ width: "1.3rem" }}
                        aria-hidden="true"
                      ></i>
                      <span className="text">{label}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </ul>
        </nav>
      </aside>
    </div>
  );
};

export default Sidebar;
